module.exports = __webpack_public_path__ + "img/dec.d23ed138.svg";